import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './chat-bot.component.scss';
import * as $ from 'jquery';
var ChatBot = /** @class */ (function (_super) {
    tslib_1.__extends(ChatBot, _super);
    function ChatBot(element) {
        var _this = _super.call(this, element) || this;
        _this.event.register('openChatBotModal', _this, _this.openChatBotModal.bind(_this));
        return _this;
    }
    ChatBot.prototype.init = function () {
        this.modals = Array.from(this.element.querySelectorAll('.js-chat-bot-modal'));
        this.modalLinks = Array.from(document.querySelectorAll('.js-chat-bot-modal-open'));
        this.closeButton = this.element.querySelector('.js-chat-bot-modal-close');
        this.openButton = this.element.querySelector('.js-chat-bot-modal-open');
        this.buttonContainer = this.element.querySelector('.chat-bot-toggle');
        this.toggleTabsButtons = Array.from(this.element.querySelectorAll('.js-toggle-tab'));
        this.tabs = Array.from(this.element.querySelectorAll('.chat-bot__tab-content'));
        this.callMeBackForm = this.element.querySelector('form');
        this.formSubmitButton = this.element.querySelector('.js-chat-bot-submit');
        this.formRadioButtons = Array.from(this.element.querySelectorAll('.js-identification_radio--group'));
        this.formSuccessMessage = this.element.querySelector('.js-chat-bot-success-message');
        this.formErrorMessage = this.element.querySelector('.js-chat-bot-error-message');
    };
    ChatBot.prototype.bindEvents = function () {
        var _this = this;
        this.modals.map(function (item) { return item.addEventListener('click', function (event) {
            _this.isClickOutsideChatBotModal(event);
        }); });
        window.addEventListener('scroll', function (event) { return _this.onScroll(event); });
        if (this.closeButton) {
            this.closeButton.addEventListener('click', function (event) { return _this.closeChatBotModal(); });
        }
        this.modalLinks.map(function (item) { return item.addEventListener('click', function (event) {
            _this.openChatBotModals(event);
        }); });
    };
    ChatBot.prototype.onScroll = function (event) {
        var _this = this;
        setTimeout(function () {
            var footerHeight = document.querySelector('footer').offsetHeight;
            if ((window.innerHeight + document.documentElement.scrollTop) >= (document.body.offsetHeight - footerHeight)) {
                _this.hideComponent();
            }
            else {
                _this.showComponent();
            }
        }, 200);
    };
    ChatBot.prototype.showComponent = function () {
        this.element.classList.remove('chat-bot--hidden');
    };
    ChatBot.prototype.hideComponent = function () {
        this.element.classList.add('chat-bot--hidden');
    };
    ChatBot.prototype.isClickOutsideChatBotModal = function (event) {
        if (event.target === this.activeModal) {
            this.closeChatBotModal();
        }
    };
    ChatBot.prototype.openChatBotModals = function (event) {
        var element = event.target;
        var modalId = element.getAttribute('data-modal');
        if (!modalId) {
            var parentElement = $(element).closest('.js-chat-bot-modal-open');
            modalId = parentElement.attr('data-modal');
        }
        this.activeModal = this.getChatBotModalById(modalId);
        this.openChatBotModal();
    };
    ChatBot.prototype.closeChatBotModal = function () {
        var _this = this;
        this.analyticsService.dtmFormAbandon();
        this.activeModal.classList.add('modal--close');
        this.activeModal.querySelector('.chat-bot__modal-dialog').classList.remove('chat-bot__modal-dialog--open');
        setTimeout(function () {
            _this.activeModal.classList.add('modal--closed');
        }, 250);
        this.showOpenButton();
    };
    ChatBot.prototype.openChatBotModal = function () {
        this.activeModal.classList.remove('modal--close');
        this.activeModal.classList.remove('modal--closed');
        this.activeModal.querySelector('.chat-bot__modal-dialog').classList.add('chat-bot__modal-dialog--open');
        this.showCloseButton();
    };
    ChatBot.prototype.getChatBotModalById = function (id) {
        return document.querySelector("#" + id);
    };
    ChatBot.prototype.showOpenButton = function () {
        var _this = this;
        this.closeButton.classList.remove('chat-bot-toggle__toggle-icon--visible');
        setTimeout(function () {
            _this.buttonContainer.classList.add('chat-bot-toggle--closed');
        }, 150);
        setTimeout(function () {
            _this.openButton.classList.add('chat-bot-toggle__toggle-text--visible');
        }, 300);
    };
    ChatBot.prototype.showCloseButton = function () {
        var _this = this;
        this.openButton.classList.remove('chat-bot-toggle__toggle-text--visible');
        setTimeout(function () {
            _this.buttonContainer.classList.remove('chat-bot-toggle--closed');
        }, 150);
        setTimeout(function () {
            _this.closeButton.classList.add('chat-bot-toggle__toggle-icon--visible');
        }, 300);
    };
    return ChatBot;
}(Base));
export { ChatBot };



//////////////////
// WEBPACK FOOTER
// ./components/chat-bot/chat-bot.component.ts
// module id = 200
// module chunks = 0